import http from '../http-common';

export const getSessions          = ()            => http.get('/sessions').then(r => r.data);
export const revokeSession        = (sessionId)    => http.delete(`/sessions/${sessionId}`).then(r => r.data);
export const revokeOtherSessions  = ()             => http.delete('/sessions/others').then(r => r.data);
export const revokeCurrentSession = ()             => http.delete('/sessions/current').then(r => r.data);
